<div class="responsive-container">
<bpc-generic-listing [tableClass]="'interaction-review-table'" [title]="'Interactions'" [columns]="interactionColumns" [companiesFilter]="interactionFilter" [data]="interactions" [totalCount]="totalCount"
    [isLoading]="isLoading" (onFilterChange)="onFilterChange($event)" (onLoadMore)="loadMoreData()" (onSelectionChange)="onCheckboxSelectionChange($event)">
    <div slot="header-options" class="col flex align-content-center flex-wrap flex-w-auto">
    </div>
    <div slot="subroutes" class="col flex align-content-center flex-wrap flex-w-auto" *ngIf="!isMobile">
      <ng-container *ngFor="let subroute of subRoutes">
        <a class="vote-tab-buttons" [routerLink]="subroute.route" [ngClass]="{ 'active': subroute.active }">
          {{subroute.label}}
        </a>
      </ng-container>
    </div>
  </bpc-generic-listing>
</div>